
import { Component, PropSync, Mixins } from 'vue-property-decorator';
import LottieAnimation from '@/features/common/components/LottieAnimation.vue';
import { CheckInReasonType } from '@/features/users/types';
import focusMixin from '../mixins/focusMixin';
import { postAccountCheckIn } from '../services/common.services';

type AnswerOptionType = {
  label: string,
  value: CheckInReasonType
}

@Component({
  components: {
    LottieAnimation,
  },
})
export default class InactiveUserPopover extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  private answerOptions: AnswerOptionType[] = [
    {
      label: this.$t('inactivePopover.options.notManyOrders') as string,
      value: 'DontShipMuch',
    },
    {
      label: this.$t('inactivePopover.options.noValue') as string,
      value: 'ValueLack',
    },
    {
      label: this.$t('inactivePopover.options.noExpectation') as string,
      value: 'Expectations',
    },
    {
      label: this.$t('inactivePopover.options.encounteredIssue') as string,
      value: 'Issues',
    },
    {
      label: this.$t('inactivePopover.options.notCompetitive') as string,
      value: 'Rates',
    },
  ];

  private otherAnswer: AnswerOptionType = {
    label: this.$t('inactivePopover.options.other') as string,
    value: 'Other',
  };

  private isShowOtherInput = false;

  private selectedAnswer: {
    answer: string,
    other: string,
    step: 'miss-u' | 'thanks',
    lottie: 'we-miss-you.json' | 'thank-you.json',
    greeting: string,
  } = {
    answer: '',
    other: '',
    step: 'miss-u',
    lottie: 'we-miss-you.json',
    greeting: this.$t('inactivePopover.missedYou') as string,
  }

  private selectAnswer(answer: { label: string, value: CheckInReasonType}) {
    this.selectedAnswer.other = '';

    if (answer.value === 'Other') {
      this.isShowOtherInput = true;
      return;
    }

    this.isShowOtherInput = false;
    this.submitAnswer(answer.value, '');
  }

  private async submitAnswer(answer: CheckInReasonType, other: string) {
    await postAccountCheckIn({
      response: other,
      reason: answer,
    });
    await this.$store.dispatch('refetchUserInfo');

    this.selectedAnswer = {
      answer,
      other,
      step: 'thanks',
      lottie: 'thank-you.json',
      greeting: this.$t('inactivePopover.thankYou') as string,
    };
  }

  private async dismiss() {
    await postAccountCheckIn({
      response: 'Dismissed',
      reason: 'Dismiss',
    });
    await this.$store.dispatch('refetchUserInfo');
    this.syncedShow = false;
  }

  private changeAnswer() {
    this.selectedAnswer = {
      answer: '',
      other: '',
      step: 'miss-u',
      lottie: 'we-miss-you.json',
      greeting: this.$t('inactivePopover.missedYou') as string,
    };
  }
}
